import * as React from 'react';
import locales from "../locales";
import SectionHeaderFormItem from "../common/form-items/SectionHeaderFormItem";
import {LoadingOverlayHandler,} from "../app/ApplicationContext";
import FileUploadEditor from "../common/input/FileUploadEditor";
import {Attachment} from "../api/dtos/dtos";

interface Props {
  id: number;
  style?: React.CSSProperties;
  onLoad: (id: number) => Promise<Attachment[]>;
  onDelete: (id: number, attachmentId: number) => Promise<void>;
  action: (id: number) => string;
}


class DocumentUploader extends React.Component<Props, {}> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: Props) {
    super(props);
    this.state = {
      recipientContacts: [],
    }
  }

  public shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<{}>, nextContext: any): boolean {
    return nextProps !== this.props;
  }


  public render(): React.ReactNode {
    const {id, onLoad, onDelete} = this.props;

    return (
      <>
        <SectionHeaderFormItem title={locales.document_upload} style={{marginTop: 48}}/>
        <FileUploadEditor
          disabled={false}
          itemId={id}
          action={this.getAction()}
          loadAttachment={onLoad}
          deleteAttachment={onDelete}
        />
      </>
    );
  }

  private getAction(): string {
    return this.props.action(this.props.id);
  }
}

export default DocumentUploader;



// WEBPACK FOOTER //
// ./src/document-sendout/DocumentUploader.tsx